import React, { useState, Fragment } from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import _ from 'lodash';
import { YamlSettingsViewComponent } from './yaml-settings-view/YamlSettingsViewComponent';
import { SyncWithSalesForceComponent } from './sync-with-salesforce/SyncWithSalesForceComponent';
import { SubmitContractComponent } from './submit-contract/SubmitContractComponent';

export const SubmitActionsComponent = ({
  handleSubmitContract,
  isSubmitLoading,
  downstreamJsonDetails,
  isSyncingWithSalesForce,
  handleSyncWithSalesForce,
  disableViewYamlSettings,
  submitStatus
}) => {
  return (
    <div className={classNames(styles.submitSyncContainer)}>
      <SubmitContractComponent
        isSubmitContractLoading={isSubmitLoading}
        disabled={isSubmitLoading || isSyncingWithSalesForce}
        handleSubmitContract={() => handleSubmitContract({ action: '' })}
      />

      <SyncWithSalesForceComponent
        isSyncingWithSalesForce={isSyncingWithSalesForce}
        disabled={isSubmitLoading || isSyncingWithSalesForce}
        handleSyncWithSalesForce={handleSyncWithSalesForce}
      />

      <YamlSettingsViewComponent
        yamlDetails={downstreamJsonDetails}
        disableViewYamlSettings={disableViewYamlSettings}
        submitStatus={submitStatus}
      />
    </div>
  );
};
